import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withKeys as _withKeys, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["aria-pressed", "button-text", "onClick", "onKeydown"]

interface Button {
  text: string
  name: string
  onClick: () => void
}


export default /*@__PURE__*/_defineComponent({
  __name: 'UnderlineTabGroup',
  props: {
    buttons: {},
    selectedName: {},
    size: {},
    tabStyle: {}
  },
  emits: ["buttonClicked"],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emits = __emit

const handleButtonClick = (name: string, event?: Event, preventDefault?: boolean) => {
  if (event && preventDefault) event.preventDefault() // Prevent space bar scrolling
  emits('buttonClicked', name)
  props.buttons.find((b) => b.name === name)?.onClick()
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["container", {
      'pill-tab-small': _ctx.tabStyle === 'pillTabSmall',
      container__small: _ctx.size === 'small'
    }])
  }, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.buttons, (button, index) => {
      return (_openBlock(), _createElementBlock("div", {
        key: index,
        "aria-pressed": _ctx.selectedName === button.name,
        class: _normalizeClass(["button", { button__small: _ctx.size === 'small', button__selected: _ctx.selectedName === button.name }]),
        "button-text": button.text,
        role: "button",
        tabindex: "0",
        onClick: ($event: any) => (handleButtonClick(button.name)),
        onKeydown: [
          _withKeys(($event: any) => (handleButtonClick(button.name)), ["enter"]),
          _withKeys((event) => handleButtonClick(button.name, event, true), ["space"])
        ]
      }, _toDisplayString(button.text), 43, _hoisted_1))
    }), 128))
  ], 2))
}
}

})